<template>
  <div>
    <div class="main-content">
      <div id="boxloading"></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <li>
              <a href="#/relation">外部ログインサービス利用設定</a>
            </li>
            <router-link tag="li" :to="{ name: 'relation-user-federated-login-service'}">
              <a>ログインユーザー登録</a>
            </router-link>
            <li class="active">ログインユーザー一括登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>ログインユーザー一括登録</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content register_user">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <!-- PAGE CONTENT BEGINS -->
                <div class="alert alert-info">
                  ログインユーザー登録の追加をCSVファイルから行うことができます。<br>
                  アップロードするCSVファイルを選択し、「ファイルをインポート」してください。
                </div>
                <div>
                  <div class="fallback">
                    <p class="desc">自分のコンピューターからファイルを選択する ：</p>
                    <label for="file_csv" class="btn-upload">
                      CSVファイルを選択
                      <input type="file" id="file_csv" style="display:none;" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple accept='.csv'>
                    </label>
                    <span class="filename">選択されていません</span>
                    <span class="error"></span>
                    <div id="result">
                    </div>
                    <button class="btn btn-info" type="button" @click="importExe" data-toggle="modal">
                      ファイルをインポート
                    </button>
                  </div>
                </div>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <!-- PAGE CONTENT BEGINS -->
                <div class="alert alert-info">
                  ログインユーザーを出力することができます。 <br>「ファイルをエクスポート」してください。
                </div>
                <div>
                  <div class="fallback">
                    <button class="btn btn-info" type="button" @click="getDataForExport(1)" data-toggle="modal">
                      ファイルをエクスポート
                    </button>
                  </div>
                </div>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">CSVファイルのインポート</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="message.length === 0">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <div v-else style="width:100%;padding:10px;border:1px solid #ccc;color:red;margin-top:10px">
              <div v-html="message"></div>
            </div>
            <span class="success-label" v-if="successItem>0">{{totalDataRow}}件中{{successItem}}件をインポートしました。</span>
            <div v-if="errorMessage.length>0">
              <span class="error-box-title">インポート失敗</span>
              <div class="error-box">
                <template v-for="item in errorMessage">
                  <p v-html="item" :key="item"></p>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success" @click="reset()">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import * as Config from '../../config'
import saveAs from 'file-saver/dist/FileSaver'
export default {
  data () {
    return {
      files: null,
      errorMessage: [],
      importData: [],
      loading: false,
      message: '',
      errorName: '',
      progress: 0,
      success: false,
      totalDataRow: 0,
      exeCount: 0,
      successItem: 0,
      percent: 0,
      isSendEmail: false,
      pagesRelation: 0,
      isVisible: false,
      exportData: [],
      dataLoad: 0,
      percentExport: 0,
      pages: 0
    }
  },
  // totalDataRowとはCSVファイルの中にある項目数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCount に１をプラスする。
  // 全部APIを実行が終わるとexeCount の値は０にリセットする。
  // exeCount<totalDataRowの時は次のAPI実行。
  // exeCount===totalDataRowの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRow) {
        vm.addExe(vm.importData[newVal][0], vm.importData[newVal][1], vm.importData[newVal][2], (newVal + 2), vm.percent)
      } else if (newVal > 0 && newVal === vm.totalDataRow) {
        this.exeCount = 0
        this.success = true
        this.importData = []
      }
    },
    dataLoad: function (newVal, oldVal) {
      if (newVal === this.pages) {
        this.isVisible = false
        this.downloadCSV()
        this.reset()
      } else if (newVal > 0) {
        this.getDataForExport(newVal + 1)
      }
    }
  },
  created () {
    this.getPages()
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    }
  },
  methods: {
    reset () {
      this.exportData = []
      this.exeCount = 0
      this.successItem = 0
      setTimeout(() => {
        this.success = false
      }, 200)
      location.reload()
    },
    previewFiles () {
      this.files = this.$refs.myFiles.files[0]
      $('.filename').html(this.files.name)
    },
    addExe (email, userId, relationOwnerFederatedLoginServiceId, z, percent) {
      var vm = this
      const Infor = {
        userId: userId,
        federatedLoginEmail: email,
        relationOwnerFederatedLoginServiceId: relationOwnerFederatedLoginServiceId
      }
      console.log(Infor)
      this.$http.post(Config.USER_FEDERATED_LOGIN_SERVICE_API, Infor)
        .then(response => {
          vm.exeCount++
          vm.successItem++
          vm.progress += percent
          console.log(response)
        })
        .catch((error) => {
          vm.exeCount++
          var rowstatus = ''
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 403:
              vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 409:
              vm.errorName = '入力されたユーザーIDは既に使用されています。他のユーザーIDを入力してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
          }
          this.$set(this.errorMessage, z, rowstatus)
          vm.progress += percent
          console.log(error)
        })
    },
    getPages () {
      var vm = this
      this.$http.get(Config.USER_FEDERATED_LOGIN_SERVICE_API)
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.pages = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentExport = (100 / (vm.pages))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    downloadCSV () {
      var vm = this
      var filename
      var csv = this.convertArrayOfObjectsToCSV({
        data: vm.exportData
      })
      filename = 'user-federated-login-data.csv'
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      var blob = new Blob([ bom, csv ], {type: 'text/csv;charset=utf-8;'})
      // ダウンロード実行
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      if (isSafari) {
        saveAs(blob, filename)
      } else {
        if (window.navigator.msSaveOrOpenBlob) {
          // IEの場合
          navigator.msSaveBlob(blob, filename)
        } else {
          // IE以外(Chrome, Firefox)
          var downloadLink = $('<a></a>')
          downloadLink.attr('href', window.URL.createObjectURL(blob))
          downloadLink.attr('download', filename)
          downloadLink.attr('target', '_blank')
          $('body').append(downloadLink)
          downloadLink[0].click()
          downloadLink.remove()
        }
      }
    },
    convertArrayOfObjectsToCSV (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data
      data = args.data || null
      if (data == null || !data.length) {
        return null
      }
      columnDelimiter = args.columnDelimiter || ','
      lineDelimiter = args.lineDelimiter || '\n'
      keys = Object.keys(data[0])
      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter
      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })
      return result
    },
    getDataForExport (page) {
      var vm = this
      this.$http.get(Config.USER_FEDERATED_LOGIN_SERVICE_API + '?limit=1000&page=' + page)
        .then(response => {
          vm.dataLoad++
          response.body.relationsUserFederatedLoginService.forEach(function (item) {
            vm.exportData.push({
              'ログインID': item.federatedLoginEmail,
              'ALLIGATEユーザID': item.userId,
              '外部ログインサービス': item.relationOwnerFederatedLoginServiceId
            })
          })
          vm.progress += vm.percentExport
        })
        .catch((error) => {
          vm.progress += vm.percentExport
          console.log(error)
        })
    },
    importExe () {
      var vm = this
      $('#process').modal({
        backdrop: 'static'
      })
      if (this.files !== null) {
        this.progress = 0
        this.errorMessage = []
        var reader = new FileReader()
        reader.onload = function () {
          var lineArr = reader.result.split('\n')
          var itemArr = []
          for (var i = 0; i < lineArr.length; i++) {
            itemArr[i] = lineArr[i].split(',')
          }
          if (itemArr.length > 1) {
            vm.importData = []
            for (var k = 1; k < itemArr.length; k++) {
              if (itemArr[k].length === 3 && itemArr[k][0].length > 0) {
                vm.importData.push(itemArr[k])
              }
            }
            console.log(vm.importData)
            if (vm.importData.length > 0) {
              vm.totalDataRow = vm.importData.length
              vm.message = ''
              vm.percent = (100 / (vm.totalDataRow))
              vm.addExe(vm.importData[0][0], vm.importData[0][1], vm.importData[0][2], 2, vm.percent)
            } else {
              vm.success = true
              vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
            }
          } else {
            vm.success = true
            vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
          }
        }
        reader.onerror = function () {
          vm.success = true
          vm.message = '選択されているファイルの読み込みに失敗しました。<br>ブラウザの更新、もしくは別ファイルを選択してから <br> 再度アップロードしたいファイルを選択してください。'
        }
        reader.readAsText(this.files, 'Shift_JIS')
      } else {
        vm.success = true
        vm.message = 'CSVのファイルを選択してください。'
      }
    }
  }
}
</script>
<style type="text/css">
#result p {
  margin-bottom: 0px
}
#result span {
  display: inline-block;
  padding: 5px;
}
#result span.error {
  color: red
}
#result span.success {
  color: #87B87F;
}
#result p.block {
  display: block;
  margin-bottom: 1px;
}
.btn-upload{
  color: white;
  background-color: #000;
  padding: 6px 15px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-block;
  margin: 0px 15px
}
.desc{
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
}
.filename{
  display: inline-block;
}
.hide{
  display: none;
}
.error{
  display: block;
  color: #FF4040
}
</style>



// WEBPACK FOOTER //
// src/views/login-service/RelationImport.vue